<template>
  <CustomTooltip>
    <TooltipBounceButton
      v-bind="$attrs"
      store-key="upload-recording-button:clicked"
      content="Click to upload"
      side="left"
      @click="onClick"
    >
      <img
        :src="UploadIcon"
        alt=""
      >
    </TooltipBounceButton>
    <template #content>
      <span>Upload</span>
      <kbd class="bg-white text-black-50 ml-1">enter</kbd>
    </template>
  </CustomTooltip>
</template>

<script setup>
import { onKeyStroke } from '@vueuse/core'
import CustomTooltip from '@/components/custom-tooltip.vue'
import { UploadIcon } from '../../../common/icons'
import TooltipBounceButton from '../../../common/tooltip-bounce-button.vue'

defineOptions({
  inheritAttrs: false,
})

const emit = defineEmits(['click'])

function onClick() {
  emit('click')
}

onKeyStroke('Enter', () => {
  onClick()
})
</script>
